module.exports = __webpack_public_path__ + "static/media/roboto-regular.479970ff.woff2";